import React from "react";
import API from '../Utils/api';
import Axios from 'axios'
import Cleave from "cleave.js/react"
import { getUsuarioFromStorage } from "../Utils/usuarioHelper";
import MasterTemplate from "./MasterTemplate";
import moment from 'moment';
import { Link } from 'react-router-dom';

export class MasterCriarPedidos extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("user")),
      gerenteSelecionado: null,
      cambistaSelecionado: null,
      clienteSelecionado: null,
      cartelaSelecionada: null,
      clientes: [],
      cambistas: [],
      gerentes: [],
      pedidoGerado: null,
      referencia: null
    }

    this.getGerentes()
    this.getReferencia()
  }

  setGerente(e) {
    this.state.gerenteSelecionado = JSON.parse(e.target.value);
    this.setState({ gerenteSelecionado: JSON.parse(e.target.value), cambistaSelecionado: null })
    this.getCambistasPorGerentes(this.state.gerenteSelecionado)
  }

  setCambista(e) {
    this.state.cambistaSelecionado = JSON.parse(e.target.value);
    this.setState({ cambistaSelecionado: JSON.parse(e.target.value) })
    this.getClientesPorCambista(this.state.cambistaSelecionado)
  }

  setCliente(e) {
    this.state.clienteSelecionado = JSON.parse(e.target.value);
    this.setState({ clienteSelecionado: JSON.parse(e.target.value) })
  }

  setCodigo(e) {
    this.state.codigo = e.target.value;
    this.setState({ codigo: e.target.value })
  }

  async getReferencia() {
    try {
      const response = await API.get("/api/pedidos/pedido-referencia-atual");
      this.setState({ referencia: response.data });

    } catch (err) {
      console.log(err);
    }
  }



  async getGerentes() {
    try {
      const response = await API.post("/api/usuarios/listar-todos-gerentes", {});
      this.setState({ gerentes: response.data.sort(this.compararNome) });

    } catch (err) {
      console.log(err);
    }
  };

  async getCambistasPorGerentes(usuario) {
    if (this.state.gerenteSelecionado != null) {
      try {
        const response = await API.post("/api/usuarios/listar-por-tutor", {
          tutorId: usuario._id
        });
        this.setState({ cambistas: response.data.sort(this.compararNome) });
        // this.buscarPedidos()
      } catch (err) {
        console.log(err);
      }
    }
    else {
      this.getCambistas()
    }

  };

  async getClientesPorCambista(usuario) {
    if (this.state.gerenteSelecionado != null && this.state.cambistaSelecionado != null) {
      try {
        const response = await API.post("/api/usuarios/listar-por-tutor", {
          tutorId: usuario._id
        });
        this.setState({ clientes: response.data.sort(this.compararNome) });
        // this.buscarPedidos()
      } catch (err) {
        console.log(err);
      }
    }

  };

  compararNome(a, b) {
    if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
      return 1;
    }
    if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
      return -1;
    }

    return 0
  }

  async pegarCartela() {
    try {
      const response = await API.post("/api/lotesDB/pegar-cartela", { codigo: this.state.codigo });
      console.log(response.data)
      if (response.data != null) {
        response.data.data = this.state.referencia.data;
        response.data.horario = this.state.referencia.horario;
        response.data.valor = this.state.referencia.valor;
        this.setState({ cartelaSelecionada: response.data });

        var pedido = {
          cartelas: [this.state.cartelaSelecionada],
          clienteId: this.state.clienteSelecionado,
          cambistaId: this.state.cambistaSelecionado,
          gerenteId: this.state.gerenteSelecionado,
          comissao: this.state.cambistaSelecionado.comissao,
          status: true,
          recebido: true,
          validado: false,
          data: new Date()
        }

        this.criarTransacao(pedido)

      }
      else {
        alert("Cartela Invalida")
      }

    } catch (err) {
      console.log(err);
    }
  };


  async criarTransacao(pedido) {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem('apiUrl')
      })
      const response = await axiosInstance.post(
        'transacoes/criar-transacao',
        {
          data: new Date(),
          documento: 'Documento Avulso',
          valor: pedido.cartelas.length * parseFloat(pedido.cartelas[0].valor),
          emissorId: pedido.clienteId._id,
          receptorId: pedido.cambistaId._id,
          tipo: 'Venda',
          observacao: 'VENDA CAMBISTA',
          status: true,
          natureza: 'ENTRADA',
          isEfetivada: false,
          taxaComissao: pedido.cartelas.length * pedido.cambistaId.comissao
        }
      )
      this.efetuarPedido(pedido, response.data)
    } catch (err) {
      console.log(err)
    }

  }

  async efetuarPedido(e, transacao) {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem('apiUrl')
      })
      const response2 = await axiosInstance.post(
        'pedidos/fazer-pedido-cambista',
        {
          cartelas: e.cartelas,
          dataCriacao: new Date(), // ATUALIZAR A DATA NO SERVIDOR
          comissao: e.cartelas.length * e.cambistaId.comissao,
          clienteId: e.clienteId._id,
          cambistaId: e.cambistaId._id,
          gerenteId: e.gerenteId._id,
          recebido: true,
          codigo: '',
          transacaoId: transacao._id
        }
      )

      if (response2) {
        this.setState({ pedidoGerado: { ...response2.data, ...e } })
        alert('Pedido criado com sucesso!')
      }


    } catch (err) {
      console.log(err)
    }
  }



  formatDate(data) {
    return moment(data).add(0, 'days').format('DD-MM-YYYY')
  }

  render() {
    return (
      <MasterTemplate label="Criar Pedidos">
        <div className="container">
          <div className="row">
            <select onChange={this.setGerente.bind(this)} style={{ maxWidth: '10em' }} class="ml-1 custom-select">
              <option value={JSON.stringify(null)} selected>Selecione um gerente</option>
              {this.state.gerentes.length > 0 ? this.state.gerentes.map(gerente => {
                return <option value={JSON.stringify(gerente)}>{gerente.nome}</option>
              }) : ""}
            </select>

            <select onChange={this.setCambista.bind(this)} style={{ maxWidth: '10em' }} class="ml-1 custom-select">
              <option value={JSON.stringify(null)} selected>Selecione um cambista</option>
              {this.state.cambistas.length > 0 ? this.state.cambistas.map(cambista => {
                return <option value={JSON.stringify(cambista)}>{cambista.nome}</option>
              }) : ""}
            </select>

            <select onChange={this.setCliente.bind(this)} style={{ maxWidth: '10em' }} class="ml-1 custom-select">
              <option value={JSON.stringify(null)} selected>Selecione um cliente</option>
              {this.state.clientes.length > 0 ? this.state.clientes.map(cliente => {
                return <option value={JSON.stringify(cliente)}>{cliente.nome} - {cliente.telefone}</option>
              }) : ""}
            </select>

            <Cleave
              data-length="7"
              className={`ml-1 form-control`}
              options={{
                numericOnly: true,
                delimiters: ['-'],
                blocks: [5, 1]
              }}

              onChange={this.setCodigo.bind(this)}
              placeholder="código 00000-0"
              style={{ maxWidth: '10em' }}
            />
            <button className="btn-fill btn btn-danger" onClick={this.pegarCartela.bind(this)}>Criar pedido</button>

          </div>
          {this.state.pedidoGerado != null ?


            <div className={'container bg-white border w-100 p-5 m-5'} >
              <div className="row">
                <span className="font-weight-bold" style={{ fontSize: '1.5em' }}>Dados do pedido gerado</span>
              </div>
              <div className="row">
                <span className="font-weight-bold" style={{ fontSize: '1em' }}>Código: </span>
                <span className="ml-2 font-weight-bold text-danger" style={{ fontSize: '1em' }}>{this.state.pedidoGerado.codigo}</span>
              </div>
              <div className="row">
                <span className="font-weight-bold" style={{ fontSize: '1em' }}>Cartela: </span>
                <span className="ml-2 font-weight-bold text-danger" style={{ fontSize: '1em' }}>{this.state.pedidoGerado.cartelas[0].codigo}</span>
              </div>
              <div className="row">
                <span className="font-weight-bold" style={{ fontSize: '1em' }}>Cliente: </span>
                <span className="ml-2 font-weight-bold text-danger" style={{ fontSize: '1em' }}>{this.state.pedidoGerado.clienteId.nome}</span>
              </div>
              <div className="row">
                <span className="font-weight-bold" style={{ fontSize: '1em' }}>Cambista: </span>
                <span className="ml-2 font-weight-bold text-danger" style={{ fontSize: '1em' }}>{this.state.pedidoGerado.cambistaId.nome}</span>
              </div>
              <div className="row">
                <span className="font-weight-bold" style={{ fontSize: '1em' }}>Gerente: </span>
                <span className="ml-2 font-weight-bold text-danger" style={{ fontSize: '1em' }}>{this.state.pedidoGerado.gerenteId.nome}</span>
              </div>
              <div className="row">
                <span className="font-weight-bold" style={{ fontSize: '1em' }}>Data: </span>
                <span className="ml-2 font-weight-bold text-danger" style={{ fontSize: '1em' }}>{this.formatDate(this.state.pedidoGerado.data)}</span>
              </div>
              <div className="row">
                {/* <span className="font-weight-bold text-secondary" style={{ fontSize: '1em' }}>Recebido aguardando validação da banca!</span> */}
              </div>


            </div>



            : ""}

        </div>
      </MasterTemplate>
    );
  }
}

export default MasterCriarPedidos;
